// Anchor classes that mirror the @mgp/ui Button look without pulling
// in the <button> primitive (we need real <a> tags so cross-origin
// portal links are crawlable + cacheable, and middle-click works).

const BASE =
  'inline-flex items-center justify-center font-medium tracking-normal whitespace-nowrap select-none ' +
  'transition-[background-color,border-color,color,box-shadow,transform] duration-fast ease-enter ' +
  'focus-visible:outline-none focus-visible:ring-4 active:scale-[0.98] motion-reduce:active:scale-100';

const SIZE = {
  sm: 'h-9 px-3.5 text-sm gap-1.5 rounded-sm',
  md: 'h-11 px-5.5 text-md gap-2 rounded-md',
  lg: 'h-13 px-7 text-lg gap-2 rounded-md',
} as const;

const VARIANT = {
  primary:
    'bg-primary text-[color:var(--color-on-primary)] border border-transparent hover:bg-primary-600 active:bg-primary-700 focus-visible:ring-primary-soft',
  secondary:
    'bg-surface text-ink border border-border-soft hover:border-border-strong hover:bg-surface-sunken active:bg-border-soft focus-visible:ring-primary-soft',
  ghost:
    'bg-transparent text-ink border border-transparent hover:bg-primary-soft hover:text-primary focus-visible:ring-primary-soft',
} as const;

export type CtaSize = keyof typeof SIZE;
export type CtaVariant = keyof typeof VARIANT;

export function ctaClass(variant: CtaVariant = 'primary', size: CtaSize = 'md'): string {
  return [BASE, SIZE[size], VARIANT[variant]].join(' ');
}
